import { CheckoutItem } from "src/types";

export type Checkout = {
  id: number;
  uuid: string;
  items: CheckoutItem[];
  discountText: string;
  price: number;
  resultPrice: number;
};

export enum CheckoutTypes {
  SET_PRICE = "SET_PRICE",
  SET = "SET_CHECKOUT",
  CLEAR = "CLEAR_CHECKOUT",
}

export type SetResultPrice = {
  type: CheckoutTypes.SET_PRICE;
  payload: number;
};

export type SetCheckout = {
  type: CheckoutTypes.SET;
  payload: Checkout;
};

export type ClearCheckout = {
  type: CheckoutTypes.CLEAR;
};

export type CheckoutActions = SetCheckout | ClearCheckout | SetResultPrice;
